import { render, staticRenderFns } from "./dangerJournalImpr.vue?vue&type=template&id=57520b0e"
import script from "./dangerJournalImpr.vue?vue&type=script&lang=js"
export * from "./dangerJournalImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57520b0e')) {
      api.createRecord('57520b0e', component.options)
    } else {
      api.reload('57520b0e', component.options)
    }
    module.hot.accept("./dangerJournalImpr.vue?vue&type=template&id=57520b0e", function () {
      api.rerender('57520b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerJournalImpr.vue"
export default component.exports